import { Injectable } from '@angular/core';

@Injectable()
export class InvoicePaymentTypes {
    public invoicePaymentTypes : any [] = [   
        { value:'partial_payment', name: 'Pago Parcial' },
        { value:'total_payment', name: 'Pago Total' }
      ];
    constructor() { }
}

